import { toast } from "react-toastify";
import { formatDistanceToNow } from "date-fns/formatDistanceToNow";
import {
  ethToDollarConverter,
  generateRiskMarketPnLPreview,
  getGeneratedPreview,
  getGeneratedProfilePreview,
} from "./services";
import CryptoJS from "crypto-js";
import { decodeEventLog, encodeFunctionData } from "viem";
import { gameFeePercentage, PAYMASTER_ADDRESS, SHARE_MARKET, SHARE_MARKET_BASE_URL, SHARE_PROFILE, USDT_SYMBOL } from "./Enviroment";
import { ethers } from "ethers";
import BalanceOfAbi from "../utils/BalanceOfAbi.json";
import { getIndexKey } from "../components/indexDb";
import Web3 from "web3";
import {
  APPEAL_WINDOW_OPEN,
  aquaChains,
  aquaTokens,
  BUY,
  CLOSED,
  CLOSING_SOON,
  DISPUTE_WINDOW_OPEN,
  LIGHT_THEME,
  LIMIT_BUY_SELL_MIN_CAP,
  LIVE,
  NEW,
  OTHER,
  PENDING_FINALLIZATION,
  TOKEN_RAIN,
  TOKEN_USDT,
  UNDER_APPEAL,
  UNDER_DISPUTE,
  WAITING_FOR_RESULT,
  WHATSAPP,
} from "./constants";
import { format } from "date-fns";
import { notifyError } from "../components/Toast";
import BigNumber from "bignumber.js";
import { DEFAULT_ERROR_HEADING } from "./ConstantMessages";

import metamaskImg from "../assets/wallets/metamask.svg";
import binanceImg from "../assets/wallets/binance.svg";
import coinbaseImg from "../assets/wallets/coinbase.svg";
import walletConnectImg from "../assets/wallets/walletconnect.svg";

const walletImages = {
  metamask: metamaskImg,
  binance: binanceImg,
  coinbase: coinbaseImg,
  walletconnect: walletConnectImg,
};

const web3 = new Web3();

export const isEthereumWalletAddress = (address) => {
  const regex = /^0x[a-fA-F0-9]{40}$/;
  return regex.test(address);
};

export const formatNumbers = (value) => {
  const absValue = Math.abs(value);

  const format = (num) => {
    return num.toFixed(2).replace(/\.00$/, "");
  };
  if (absValue >= 1_000_000_000) {
    return format(value / 1_000_000_000) + "B";
  } else if (absValue >= 1_000_000) {
    return format(value / 1_000_000) + "M";
  } else if (absValue >= 1_000) {
    return format(value / 1_000) + "K";
  } else {
    return format(value);
  }
};

export const roundOffNumber = (num) => {
  if (num === null || num === undefined || isNaN(num)) {
    return 0;
  }
  return Math.round(num);
};

export const formatNumberWithCommas = (value) => {
  if (value == null || isNaN(value)) return "0";
  return Math.floor(value).toLocaleString();
};

export const convertMsToMin = (ms) => {
  if (!ms || isNaN(ms)) return 0;
  return Math.floor(ms / 60000);
};

export const getFormatedWeb3Address = (address, isWalletAddress) => {
  if (isWalletAddress) {
    return `${address?.substring(0, 6)}...${address?.substring(38)}`;
  } else {
    return `${address?.substring(0, 6)}...${address?.substring(62)}`;
  }
};

export const shiftStringToSubstring = (str, start, end) => {
  if (!str) return "";
  return `${str.substring(start, end)}.....${str.substring(str.length - end)}`;
};

export const formatPrice = (value) => {
  if (!value.startsWith("0")) {
    return "";
  }
  let formattedValue = value.replace(/[^0-9.]/g, "");
  if (formattedValue.includes(".")) {
    const parts = formattedValue.split(".");
    formattedValue = parts[0] + "." + (parts[1] || "").substring(0, 2);
  }
  return formattedValue;
};

export const CalculateFeePreTx = (
  preTxLiquidity,
  platformfee,
  creatorfee,
  liquidityfee,
  ressolvorfee
) => {
  const platformFee = Number(((platformfee / 10) * preTxLiquidity) / 100);
  const creatorFee = Number(((creatorfee / 10) * preTxLiquidity) / 100);
  const liquidityFee = Number(((liquidityfee / 10) * preTxLiquidity) / 100);
  const resolverFee = Number(((ressolvorfee / 10) * preTxLiquidity) / 100);
  const ResFee = Number(platformFee + creatorFee + liquidityFee + resolverFee);
  return ResFee;
};

export const getBackgroundColor = (index, theme, totalOptions) => {
  if (index === totalOptions - 1) {
    return "#e3e1e1ff";
  }
  let background;
  if (theme === LIGHT_THEME) {
    switch (index % 26) {
      case 0:
        background = "#F9AD51";
        break;
      case 1:
        background = "#22AC00";
        break;
      case 2:
        background = "#8559E3";
        break;
      case 3:
        background = "#FE5C32";
        break;
      case 4:
        background = "#FF0066";
        break;
      case 5:
        background = "#FFFF66";
        break;
      case 6:
        background = "#66FF66";
        break;
      case 7:
        background = "#FF66FF";
        break;
      case 8:
        background = "#00FF66";
        break;
      case 9:
        background = "#FF0099";
        break;
      case 10:
        background = "#33FF99";
        break;
      case 11:
        background = "#33FF33";
        break;
      case 12:
        background = "#00FFFF";
        break;
      case 13:
        background = "#FF3399";
        break;
      case 14:
        background = "#FF6600";
        break;
      case 15:
        background = "#00FF99";
        break;
      case 16:
        background = "#99FF00";
        break;
      case 17:
        background = "#FF3300";
        break;
      case 18:
        background = "#00FFCC";
        break;
      case 19:
        background = "#66FFCC";
        break;
      case 20:
        background = "#FF0099";
        break;
      case 21:
        background = "#FF99CC";
        break;
      case 22:
        background = "#CCFF00";
        break;
      case 23:
        background = "#FF33FF";
        break;
      case 24:
        background = "#FFCC00";
        break;
      case 25:
        background = "#CC33FF";
        break;
      default:
        background = "#00CCFF";
    }
    return background;
  } else {
    switch (index % 26) {
      case 0:
        background = "#FF073A";
        break;
      case 1:
        background = "#FF5F1F";
        break;
      case 2:
        background = "#FFFF00";
        break;
      case 3:
        background = "#39FF14";
        break;
      case 4:
        background = "#00C8FF";
        break;
      case 5:
        background = "#9400D3";
        break;
      case 6:
        background = "#FF1493";
        break;
      case 7:
        background = "#BFFF00";
        break;
      case 8:
        background = "#00FFEC";
        break;
      case 9:
        background = "#FF00FF";
        break;
      case 10:
        background = "#A175C3";
        break;
      case 11:
        background = "#FFDAB9";
        break;
      case 12:
        background = "#FF7F50";
        break;
      case 13:
        background = "#E6E6FA";
        break;
      case 14:
        background = "#3EB489";
        break;
      case 15:
        background = "#40E0D0";
        break;
      case 16:
        background = "#D39AFD";
        break;
      case 17:
        background = "#FF6EB6";
        break;
      case 18:
        background = "#DEED72";
        break;
      case 19:
        background = "#FFA089";
        break;
      case 20:
        background = "#D21F3C";
        break;
      case 21:
        background = "#DE3163";
        break;
      case 22:
        background = "#E7C767";
        break;
      case 23:
        background = "#008080";
        break;
      case 24:
        background = "#FFD700";
        break;
      case 25:
        background = "#C0C0C0";
        break;
      default:
        background = "#C0C0C0"; // Fallback to the first color
    }
    return background;
  }
};

export const getUsdtPayoutOrders = (pricePerShare, quantity) => {
  const usdtPayout = pricePerShare * quantity;
  return usdtPayout;
};

export const getSellingShares = (
  sharesBuying,
  userPostSellOrderShares,
  index
) => {
  const sharesBuyingIndexNum = Number(sharesBuying);
  const userPostSellOrderSharesIndex =
    userPostSellOrderShares?.length > 0 ? userPostSellOrderShares[index] : 0;
  const RemainingShares = sharesBuyingIndexNum - userPostSellOrderSharesIndex;
  return RemainingShares;
};

export const getSocketOrderWithOptionName = (order, pool) => {
  const matchedOption = pool?.options?.find(
    (opt) => opt.choiceIndex === order?.orderOption
  );
  if (matchedOption) {
    order.optionDetail = {
      optionName: matchedOption.optionName,
      optionID: matchedOption?._id,
    };
  }
  return order;
};

export const extractStreamingId = (url) => {
  try {
    const urlObj = new URL(url);
    const hostname = urlObj.hostname;
    const pathname = urlObj.pathname;
    const searchParams = urlObj.searchParams;

    if (hostname.includes("youtube.com")) {
      if (pathname === "/watch") {
        return searchParams.get("v");
      } else if (
        pathname.startsWith("/live/") ||
        pathname.startsWith("/embed/")
      ) {
        return pathname.split("/")[2];
      }
    }

    if (hostname === "youtu.be") {
      return pathname.split("/")[1];
    }

    return null;
  } catch (error) {
    console.error("Invalid YouTube URL:", url);
    return null;
  }
};

export const CalculateTotalSharesandPrice = (sharesAmount, pricePerShare) => {
  const sharesAmountNum = Number(sharesAmount);
  const pricePerShareNum = Number(pricePerShare);
  const totalofPriceandShare = sharesAmountNum / pricePerShareNum;
  return totalofPriceandShare;
};

export const sortOrdersByPriceDifference = (orderType) => (asc, desc) => {
  if (orderType === true) {
    return Number(asc?.pricePerShare) - Number(desc?.pricePerShare);
  } else {
    return Number(desc?.pricePerShare) - Number(asc?.pricePerShare);
  }
};

export const handleDeposit = async ({
  transferFunction,
  amount,
  tokenConfig,
  balance,
  toAddress,
  setIsLoading,
  onSuccess,
  onError,
}) => {
  if (!amount || +amount <= 0) {
    notifyError(DEFAULT_ERROR_HEADING, "Please enter an amount.");
    return;
  }

  if (+amount > +balance) {
    notifyError("Your wallet is too dry", "Try to make a smaller deposit.");
    return;
  }

  setIsLoading(true);
  try {
    const result = await transferFunction(toAddress, amount, tokenConfig);
    if (result) {
      onSuccess?.(result);
      return result;
    }
  } catch (error) {
    console.error("Transfer Error:", error);
    onError?.(error);
  } finally {
    setIsLoading?.(false);
  }
};

export const handleCopy = (text) => {
  const textToCopy = text;
  const tempTextArea = document.createElement("textarea");
  tempTextArea.value = textToCopy;
  document.body.appendChild(tempTextArea);
  tempTextArea.select();
  document.execCommand("copy");
  document.body.removeChild(tempTextArea);
};



export const handleToFixedOnDecimals = (input) => {
  let num = Number(input);
  if (isNaN(num) || !isFinite(num)) return 0;

  if (num === 0) return 0;

  return Number(num.toFixed(2));
};

export const getEthToDollarValue = async (
  smartAccountUsdtBalance,
  smartAccountEthBalance
) => {
  try {
    const ethAmountInUsdt = await ethToDollarConverter();
    const portfolioValueInUsdt =
      +smartAccountUsdtBalance + +smartAccountEthBalance * +ethAmountInUsdt;
    return portfolioValueInUsdt;
  } catch (error) {
    console.error("Failed to fetch balance.");
  }
};

export const encrypt = (text, secret) => {
  if (!text || !secret) {
    throw new Error("Both text and secret are required");
  }
  const encrypted = CryptoJS.AES.encrypt(text, secret);
  return encrypted.toString();
};
export const decrypt = (cipherText, secret) => {
  const bytes = CryptoJS.AES.decrypt(cipherText, secret);
  return bytes.toString(CryptoJS.enc.Utf8);
};

export const getTxHashAndReceipt = async ({
  preparedCallId,
  smartAccountClient,
  publicClient,
  timeout = 60_000,
  interval = 2000,
}) => {
  const startTime = Date.now();
  let txHash = null;

  while (Date.now() - startTime < timeout) {
    const status = await smartAccountClient.getCallsStatus(preparedCallId);
    const possibleTxHashes = [
      status.transactionHash,
      status.txHash,
      status.hash,
      status.receipt?.transactionHash,
      status.receipts?.[0]?.transactionHash,
      status.userOperationReceipt?.transactionHash,
      status.result?.transactionHash,
      status.data?.transactionHash,
    ];
    txHash = possibleTxHashes.find(Boolean);
    if (txHash) break;
    await new Promise((resolve) => setTimeout(resolve, interval));
  }
  if (!txHash) {
    throw new Error("Transaction hash not found within timeout");
  }
  const receipt = await publicClient.getTransactionReceipt({ hash: txHash });
  return { txHash, receipt };
};

export const getPoolAddressFromReceipt = async (receipt, abi) => {
  let poolAddress = null;
  for (const log of receipt.logs) {
    try {
      const decodedLog = decodeEventLog({
        abi,
        data: log.data,
        topics: log.topics,
      });

      if (decodedLog.eventName === "PoolCreated") {
        poolAddress =
          decodedLog.args.pool ||
          decodedLog.args.poolAddress ||
          decodedLog.args.newPool;
        break;
      }
    } catch (error) {
      continue;
    }
  }
  return poolAddress;
};

export const formatDates = (isoDateString) => {
  const date = new Date(isoDateString);
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");
  const year = date.getUTCFullYear();

  return `${month}/${day}/${year}`;
};

export const formatTimeTo12Hour = (isoDateString) => {
  const date = new Date(isoDateString);
  let hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  const minutesStr = String(minutes).padStart(2, "0");
  return `${hours}:${minutesStr} ${ampm}`;
};

export const validateLink = (link) => {
  try {
    const url = new URL(link);
    return url.protocol === "http:" || url.protocol === "https:" ? link : null;
  } catch {
    return null;
  }
};

export const generatePoolShareMessage = (
  poolQuestion,
  poolId,
  poolAccessCode,
  isPoolPrivate,
  platform = "other"
) => {
  const isWhatsApp = platform === WHATSAPP;
  let message = isWhatsApp ? `*${poolQuestion}*\n` : `${poolQuestion}\n`;
  if (isPoolPrivate) {
    message += `Access Code: ${poolAccessCode}\n`;
  }
  message += `Invite Link: ${SHARE_MARKET}/?id=${poolId}`;
  return message;
};
export const generateProfileShareMessage = (
  userId,
  username,
  walletAddress,
  pnl
) => {
  const displayName = username || walletAddress;
  const label = username ? "Username" : "WalletAddress";

  return (
    `${label}: ${displayName} | PnL: ${pnl}\n` +
    `View Profile: ${SHARE_PROFILE}?id=${userId}`
  );
};

export const generateGamePnLMessage = (txHash) => {
  return `Check out my Risk Market PnL on Risk Market!\n` + `View this risk market: ${SHARE_MARKET_BASE_URL}share/risk?transactionHash=${txHash}`;
}

export const sharePoolEmail = async (
  poolQuestion,
  poolId,
  tokenLogo,
  tokenAddress,
  tokenName,
  poolAccessCode,
  isPoolPrivate,
  totalVolume,
  volumn,
  poolOptions
) => {
  const message = generatePoolShareMessage(
    poolQuestion,
    poolId,
    poolAccessCode,
    isPoolPrivate
  );
  const emailSubject = encodeURIComponent("Check out this Market invitation!");
  const emailBody = encodeURIComponent(message);
  const emailUrl = `mailto:?subject=${emailSubject}&body=${emailBody}`;
  window.location.href = emailUrl;
  const rawPayload = {
    poolId: poolId,
    title: poolQuestion,
    isPrivate: isPoolPrivate ? true : false,
    tokenSymbol: tokenLogo,
    tokenAddress: tokenAddress,
    tokenName: tokenName,
    volume: totalVolume?.toString() || "0",
    options:
      poolOptions?.map((option, index) => {
        const optionVolume = volumn?.find((vol) => +vol.option === index + 1);
        const optionVolumeStr = optionVolume?.totalVolume?.toString() || "0";
        const optionVolumeFormatted = convertFromWei(
          optionVolumeStr,
          "mwei"
        );
        return {
          optionName: option.optionName,
          totalVolume: formatNumbers(+optionVolumeFormatted),
        };
      }) || [],
  };
  const formattedPayload = preparePreviewPayload(rawPayload);
  await getGeneratedPreview(formattedPayload);
};

export const shareProfileEmail = async (
  username,
  userId,
  walletAddress,
  pnl,
  profileImageUrl
) => {
  try {
    const message = generateProfileShareMessage(
      userId,
      username,
      walletAddress,
      pnl,
      profileImageUrl
    );
    const emailSubject = encodeURIComponent("Check out this Rain Profile!");
    const emailBody = encodeURIComponent(message);
    const emailUrl = `mailto:?subject=${emailSubject}&body=${emailBody}`;
    window.location.href = emailUrl;
    const rawPayload = {
      userId,
      username: username,
      walletAddress,
      pnl,
      profileImageUrl,
    };
    await getGeneratedProfilePreview(rawPayload);
  } catch (error) {
    console.error("Error sharing profile via email:", error);
  }
};

export const sharePoolToSocials = async (
  url,
  poolQuestion,
  poolId,
  poolAccessCode,
  isPoolPrivate,
  totalVolume,
  volumn,
  poolOptions,
  token
) => {
  const platform = url?.includes("wa.me") ? WHATSAPP : OTHER;
  const message = generatePoolShareMessage(
    poolQuestion,
    poolId,

    poolAccessCode,
    isPoolPrivate,
    platform
  );
  const socialUrl = `${url}=${encodeURIComponent(message)}`;
  window.open(socialUrl, "_blank");
  const rawPayload = {
    poolId: poolId,
    title: poolQuestion,
    isPrivate: isPoolPrivate ? true : false,
    tokenSymbol: token?.tokenLogo,
    tokenAddress: token?.tokenAddress,
    tokenName: token?.tokenName,
    volume: totalVolume?.toString() || "0",
    options:
      poolOptions?.map((option, index) => {
        const optionVolume = volumn?.find((vol) => +vol.option === index + 1);
        const optionVolumeStr = optionVolume?.totalVolume?.toString() || "0";
        const optionVolumeFormatted = convertFromWei(
          optionVolumeStr,
          token?.tokenSymbol === USDT_SYMBOL ? "mwei" : "ether"
        );
        return {
          optionName: option.optionName,
          totalVolume: formatNumbers(+optionVolumeFormatted),
        };
      }) || [],
  };
  const formattedPayload = preparePreviewPayload(rawPayload);
  await getGeneratedPreview(formattedPayload);
};

export const shareProfiletoSocials = async (
  url,
  userId,
  username,
  walletAddress,
  pnl,
  profileImageUrl
) => {
  try {
    const message = generateProfileShareMessage(
      userId,
      username,
      walletAddress,
      pnl,
      profileImageUrl
    );
    const socialUrl = `${url}=${encodeURIComponent(message)}`;
    window.open(socialUrl, "_blank");
    const rawPayload = {
      userId,
      username: username,
      walletAddress,
      pnl,
      profileImageUrl,
    };
    await getGeneratedProfilePreview(rawPayload);
  } catch (error) {
    console.error("Error sharing profile:", error);
  }
};

export const shareRiskMarketPnLtoSocials = ({
  url,
  userId,
  name,
  walletAddress,
  percentage,
  exposureAmount,
  realizedPnl,
  transactionHash,
  profileImageUrl
}) => {
  const message = generateGamePnLMessage(transactionHash);
  const socialUrl = `${url}=${encodeURIComponent(message)}`;

  window.open(socialUrl, '_blank');

  generateRiskMarketPnLPreview({
    userId,
    name,
    walletAddress,
    percentage,
    exposureAmount,
    realizedPnl,
    transactionHash,
    profileImageUrl
  });
};


export const shareRiskMarketPnLtoEmail = async ({
  userId,
  name: userName,
  walletAddress: smartAccount,
  percentage: multiplier,
  exposureAmount,
  realizedPnl,
  transactionHash,
  profileImageUrl,
  isCopyToClipboard
}) => {
  try {
    const message = generateGamePnLMessage(transactionHash);

    if (isCopyToClipboard) {
      // ✅ iOS-safe clipboard copy
      const textarea = document.createElement('textarea');
      textarea.value = message;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';

      document.body.appendChild(textarea);
      textarea.select();
      textarea.setSelectionRange(0, textarea.value.length);

      document.execCommand('copy');
      document.body.removeChild(textarea);
    } else {
      const emailSubject = encodeURIComponent("Check out this Rain Risk Market!");
      const emailBody = encodeURIComponent(message);
      window.location.href = `mailto:?subject=${emailSubject}&body=${emailBody}`;
    }

    // analytics / preview (async, allowed)
    const rawPayload = {
      userId,
      name: userName,
      walletAddress: smartAccount,
      percentage: multiplier,
      exposureAmount,
      realizedPnl,
      transactionHash,
      profileImageUrl
    };

    await generateRiskMarketPnLPreview(rawPayload);
  } catch (err) {
    console.error("Email share failed:", err);
  }
};



export const sendGasFeeAsUsdt = (usdtForGas) => {
  const usdtForGasinMwei = ethers.parseUnits(usdtForGas?.toFixed(6), 6);

  const encodedTransferCall = encodeFunctionData({
    abi: BalanceOfAbi,
    functionName: "transfer",
    args: [PAYMASTER_ADDRESS, usdtForGasinMwei],
  });
  return encodedTransferCall;
};

export const ethToDollarConversion = async (ethAmount) => {
  const ethAmountInUsdt = await ethToDollarConverter();
  return ethAmountInUsdt * ethAmount;
};

export const handleGasFeeWithBuffer = async (
  smartAccount,
  callArguments,
  alchemy
) => {
  if (callArguments) {
    const gasPrice = await alchemy.core.getGasPrice();
    const estimatedGasList = await Promise.all(
      callArguments.map(async (call) => {
        return alchemy.core.estimateGas({
          from: smartAccount,
          to: call.to,
          data: call.data,
        });
      })
    );

    const estimatedGas = estimatedGasList.reduce(
      (acc, gas) => acc + gas.toBigInt(),
      0n
    );
    const totalEstimatedGas = ethers.formatEther(
      +estimatedGas?.toString() * +gasPrice?.toString()
    );
    const gasFeeInDollars = await ethToDollarConversion(totalEstimatedGas);
    const bufferedGasFee = (gasFeeInDollars * 140) / 100; // 40% increase in gas fee

    return bufferedGasFee;
  }
};

export const handleGasFeeWithPreparedCalls = async (
  smartAccountClient,
  smartAccount,
  callArgs
) => {
  const preparedCalls = await smartAccountClient.prepareCalls({
    calls: callArgs,
    from: smartAccount,
  });
  const { data } = preparedCalls;
  const callGasLimit = Number(data.callGasLimit);
  const verificationGasLimit = Number(data.verificationGasLimit);
  const preVerificationGas = Number(data.preVerificationGas);
  const maxFeePerGas = Number(data.maxFeePerGas);
  const totalGasLimit =
    callGasLimit + verificationGasLimit + preVerificationGas;
  const totalCostWei = totalGasLimit * maxFeePerGas;
  const totalCostEth = totalCostWei / 1e18;
  const gasFeeInDollars = await ethToDollarConversion(totalCostEth);
  const bufferedGasFee = (gasFeeInDollars * 140) / 100;
  return bufferedGasFee;
};

export const handleCheckSession = async () => {
  const currentTime = Math.floor(Date.now() / 1000);
  const sessionExpiryTime = Number(
    localStorage.getItem("sessionExpiryTime") ?? 0
  );
  const stored = await getIndexKey("sessionKeyData");
  const isSessionValid = currentTime >= sessionExpiryTime || !stored;
  return isSessionValid;
};

export const getMarketEndTime = (poolEndtime) => {
  const endTime = new Date(poolEndtime);
  const currentTime = new Date();
  const diffInMs = endTime - currentTime;
  if (diffInMs <= 0) return "Ended";
  const diffInMins = Math.floor(diffInMs / (1000 * 60));
  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
  const days = diffInDays;
  const hours = diffInHours % 24;
  const mins = diffInMins % 60;
  if (days > 0) {
    return `${days}d ${hours}h`;
  } else if (hours > 0) {
    return `${hours}h ${mins}m`;
  } else {
    return `${mins}m`;
  }
};

export const renderOptions = (options, limit, isPrivatePoolData, theme) => {
  const visible = options?.slice(0, limit);
  const ui = [];

  visible.forEach((opt, i) => {
    const words = opt.optionName.split(" ");
    const isLong = words.length > 5;
    ui.push(
      <div key={opt._id} className="single-option">
        <h6>
          <span
            className="circlebg"
            style={{
              backgroundColor: getBackgroundColor(i, theme, options?.length),
            }}
          ></span>
          {isPrivatePoolData ? (
            <>[PRIVATE]</>
          ) : isLong ? (
            <>{words.slice(0, 5).join(" ")}...</>
          ) : (
            opt.optionName
          )}
        </h6>
        <h5>{formatNumbers(+opt.percentage)}%</h5>
      </div>
    );
  });

  if (options?.length > limit) {
    const remaining = options?.slice(limit);
    const maxExtraColors = 4;
    const remainingCount = remaining.length;
    const remainingPercentage = remaining.reduce(
      (sum, opt) => sum + opt.percentage,
      0
    );

    ui.push(
      <div
        key="more-options"
        className="single-option moreoptions"
        style={{ cursor: "pointer" }}
      >
        <h6>
          <div className="multi-list-bg">
            {remaining?.slice(0, maxExtraColors)?.map((_, idx) => (
              <span
                key={idx}
                className="circlebg"
                style={{
                  background: getBackgroundColor(limit + idx, theme),
                }}
              ></span>
            ))}
          </div>
          {remainingCount > 0 && <>+{remainingCount}More</>}
        </h6>
        <h5>{formatNumbers(+remainingPercentage)}%</h5>
      </div>
    );
  }

  return ui;
};

export const convertFromWeiEthers = (value, decimals) => {
  if (!value || !decimals) return "0";
  try {
    const bigIntValue = new BigNumber(value);
    return ethers.formatUnits(bigIntValue?.toFixed(0), decimals);
  } catch (error) {
    console.error("Conversion error:", error);
    return "0";
  }
};


export const convertToWeiEthers = (value, decimals) => {
  if (!value || !decimals) return "0";
  try {
    return ethers.parseUnits(value.toString(), decimals).toString();
  } catch (error) {
    console.error("Conversion error:", error);
    return "0";
  }
};

export const convertFromWei = (value, unit = "mwei") => {
  if (!value) return "0";
  try {
    const bigIntValue = new BigNumber(value);
    return web3.utils.fromWei(bigIntValue?.toFixed(0), unit);
  } catch (error) {
    console.error("Conversion error:", error);
    return "0";
  }
};
export const convertFromMweiToFIxed = (value, unit = "mwei") => {
  if (!value) return "0.00";
  try {
    const converted = web3.utils.fromWei(value.toString(), unit);
    return parseFloat(converted).toFixed(2);
  } catch (error) {
    console.error("Conversion error:", error);
    return "0.00";
  }
};

// let convertedAmount = web3.utils.toWei(
//     parseFloat(amount).toFixed(6).toString(),
//     "mwei"
//   );

export const convertToMwei = (value, unit = "mwei") => {
  if (!value || !unit) return "0.00";
  try {
    const convertedAmount = web3.utils.toWei(value.toString(),
      unit
    );
    return convertedAmount;
  } catch (error) {
    console.error("Conversion error:", error);
    return "0.00";
  }
};

export const getTokenByKey = (key) => {
  return aquaTokens.find((token) => token.key === key);
};

export const getChainByKey = (key) => {
  return aquaChains.find((chain) => chain.key === key);
};

export const getTimeInAges = (time) => {
  const lastUpdated = time
    ? formatDistanceToNow(new Date(time), { addSuffix: true })
      .replace("about ", "")
      .replace("less than a", "<1")
      .replace(" hours", "h")
      .replace(" hour", "h")
      .replace(" minutes", "m")
      .replace(" minute", "m")
      .replace(" month", "mo")
      .replace(" months", "mo")
      .replace(" days", "d")
      .replace(" day", "d")
      .replace(" Year", "y")
      .replace(" Years", "y")
    : "Unknown time";
  return lastUpdated;
};

export const getDateInSlashes = (date) => {
  const lastUpdated = date
    ? format(new Date(date), "dd/MM/yyyy")
    : "Unknown Date";
  return lastUpdated;
};

export const getDateNTimeInSlashes = (date) => {
  const lastUpdated = date
    ? format(new Date(date), "MMM dd, yyyy hh:mm a")
    : "Unknown Date";
  return lastUpdated;
};

export const getPoolsStatus = (filter) => {
  switch (filter) {
    case WAITING_FOR_RESULT:
      return "Waiting_for_Result";
    case LIVE:
      return "Live";
    case UNDER_DISPUTE:
      return "Under_Dispute";
    case UNDER_APPEAL:
      return "Under_Appeal";
    case CLOSED:
      return "Closed";
    case CLOSING_SOON:
      return "Closing_Soon";
    case NEW:
      return "New";
    case DISPUTE_WINDOW_OPEN:
      return "Dispute_Window_Open";
    case APPEAL_WINDOW_OPEN:
      return "Appeal_Window_Open";
    case PENDING_FINALLIZATION:
      return "Pending_Finalization";
    default:
      return "";
  }
};

export const preparePreviewPayload = (previewData) => {
  const { poolId, title, isPrivate, tokenSymbol, tokenAddress, tokenName, category, volume, options } = previewData;
  return {
    poolId,
    title,
    isPrivate,
    tokenSymbol,
    tokenAddress,
    tokenName,
    category,
    volume: volume || "0",
    options: options.map((option) => ({
      optionName: option.optionName,
      totalVolume: option.totalVolume || "0",
    })),
  };
};

export const formatBlogsDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
};

export const formatFileSize = (bytes) => {
  if (bytes < 1024) return `${bytes} bytes`;
  else if (bytes < 1048576) return `${(bytes / 1024).toFixed(2)} KB`;
  else return `${(bytes / 1048576).toFixed(2)} MB`;
};

export const truncateLongTexts = (text, textLength) => {
  if (!text) return "";
  return text.length > textLength
    ? `${text.substring(0, textLength)}...`
    : text;
};
export const calculateWinningOptionPayout = ({
  swapbalance,
  optionId,
  individualPercent,
  claimvalue,
}) => {
  try {
    const claimValue =
      (swapbalance[optionId] / individualPercent) * claimvalue.winningPoolShare;
    const liquidityValue =
      (claimvalue.userLiquidity / claimvalue.totalLiquidity) *
      claimvalue.liquidityShare;
    const totalPayout = claimValue + liquidityValue;
    return isNaN(totalPayout) || totalPayout < 0 ? 0 : totalPayout;
  } catch (error) {
    console.error("Error calculating payout:", error);
    return 0;
  }
};

export const truncateUrl = (url, start = 25, end = 15) => {
  if (!url) return "";
  if (url.length <= start + end) return url;

  return `${url.substring(0, start)}...${url.substring(url.length - end)}`;
};

export const formatSmartDecimal = (value) => {
  if (value === null || value === undefined) return value;
  const str = value.toString();
  if (!str.includes('.')) return str;
  const [intPart, decimalPart] = str.split('.');
  if (/^0+$/.test(decimalPart)) {
    return intPart;
  }
  let nonZeroCount = 0;
  let result = '';
  let firstNonZeroSeen = false;
  for (let digit of decimalPart) {
    result += digit;
    if (digit !== '0') {
      nonZeroCount++;
      firstNonZeroSeen = true;
    } else if (firstNonZeroSeen && nonZeroCount === 1) {
      break;
    }
    if (nonZeroCount === 2) break;
  }
  result = result.replace(/0+$/, '');
  return result ? `${intPart}.${result}` : intPart;
};

export const convertXvalueToPercentage = (value) => {
  const result = ((value - 1) * 100)?.toFixed(0)
  return result
}
export const convertXvalueToPercentageOnlyForPayoutX = (value) => {
  let result = parseInt((value - 1) * 100);
  return result
}

export const epochToDateFormate = (epochTime, isDate) => {
  let date
  if (isDate) {
    date = new Date(
      epochTime * 1000
    ).toLocaleString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    })
  } else {
    date = new Date(
      epochTime * 1000
    ).toLocaleString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
  }
  return date
}

export const convertBetAmountWithOutFee = (betAmount, isBetAmount) => {
  let result
  if (isBetAmount) {
    result = betAmount - (betAmount * gameFeePercentage)
  } else {
    result = betAmount * gameFeePercentage
  }
  return formatSmartDecimal(result)
}

export const convertPercentageToXValue = (percentage) => {
  return (percentage / 100) + 1 // no toFixed here
}

export const calculationForPayOut = (multiplier, betAmount) => {
  const result =
    convertPercentageToXValue(multiplier) *
    convertBetAmountWithOutFee(+betAmount, true)
  return formatSmartDecimal(result)
}

export const addSeparatorInCrashValue = (value) => {
  if (value == null) return "0";

  const cleanedValue =
    typeof value === "string"
      ? value.replace(/,/g, "")
      : value;

  const num = Number(cleanedValue);

  if (!Number.isFinite(num)) return "0";

  return Math.floor(num).toLocaleString();
};

export const formatNumberWithCommasForRiskmarket = (value) => {
  if (value == null || isNaN(value)) return "0";

  return Number(value).toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};
export const getTokenSymbol = (tokenSymbol, usdtIcon) => {
  return tokenSymbol === TOKEN_RAIN ? (
    <img src="/assets/rain-icon.svg" alt="token" />
  ) : tokenSymbol === USDT_SYMBOL && usdtIcon ? (
    <img src="/assets/usdt-icon-new.svg" alt="token" />
  ) : (
    "$"
  );
};

export const validateOrderValue = (amount, tokenPrice, tokenSymbol, orderType, totalofPriceandShare = null) => {
  if (tokenSymbol === USDT_SYMBOL) {
    if (orderType === BUY) {
      if (+amount < LIMIT_BUY_SELL_MIN_CAP) {
        return `Amount to buy should be greator or equal to minimum order value $${LIMIT_BUY_SELL_MIN_CAP}`;
      }
    } else {
      if (+totalofPriceandShare < LIMIT_BUY_SELL_MIN_CAP) {
        return `Estimated ${TitleCaseConversion(TOKEN_USDT)} should be minimum $${LIMIT_BUY_SELL_MIN_CAP}`;
      }
    }
  } else {
    if (amount > 0 && +tokenPrice > 0) {
      if (orderType === BUY) {
        const usdEquivalent = +amount * +tokenPrice;
        if (usdEquivalent < LIMIT_BUY_SELL_MIN_CAP) {
          return `Amount to buy should be greater or equal to minimum order value ${formatNumbers(LIMIT_BUY_SELL_MIN_CAP / tokenPrice)} ${TitleCaseConversion(TOKEN_RAIN)}`;
        }
      } else {
        const minSharesRequired = LIMIT_BUY_SELL_MIN_CAP / tokenPrice;
        if (totalofPriceandShare < minSharesRequired) {
          return `Estimated ${TitleCaseConversion(TOKEN_RAIN)} should be ${formatNumbers(minSharesRequired)} ${TitleCaseConversion(TOKEN_RAIN)} equivalent to $${LIMIT_BUY_SELL_MIN_CAP}`;
        }
      }
    }
  }
  return null;
};

export const TitleCaseConversion = (word) => {
  if (!word) return "";
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}


export const getWalletImage = (name) => {
  const key = name.toLowerCase();

  if (key.includes("metamask")) return walletImages.metamask;
  if (key.includes("binance")) return walletImages.binance;
  if (key.includes("coinbase")) return walletImages.coinbase;
  if (key.includes("walletconnect")) return walletImages.walletconnect;

  return null;
};

export const shortenName = (name) => {
  if (!name) return "";
  return name.length > 8 ? name.slice(0, 8) + "..." : name;
};
export const shortenAddress = (address, chars = 4) => {
  if (!address) return "";
  return `${address.slice(0, 2 + chars)}...${address.slice(-chars)}`;
}